<template>
  <div class="page">
    <div class="logo" @click="changePage('/home')"></div>
    <div class="icon2"></div>
    <div class="icon3"></div>
    <div class="iconCustomer" ></div>
  </div>
</template>
<script setup lang="ts">
const changePage = function (pageName: string) {
  router.push(pageName)
}
</script>
<style scoped>
.logo {
  margin-top: 6.5rem;
  margin-left: 5.63rem;
  width: 8.19rem;
  height: 9rem;
  background-image: url(/src/assets/img/icon.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
  z-index: 99;
  position: relative;
}

.icon2 {
  position: relative;
  margin-top: 7.38rem;
  margin-left: 5.88rem;
  width: 31.19rem;
  height: 4.94rem;
  background-image: url(/src/assets/img/faq/icon2.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}
.icon3 {
  position: relative;
  margin-top: 4.94rem;
  margin-left: 5.88rem;
  width: 24.44rem;
  height: 20.06rem;
  background-image: url(/src/assets/img/faq/icon3.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}
.iconCustomer {
  position: fixed;
  right: 2.5rem;
  bottom: 5.06rem;
  width: 42.06rem;
  height: 22.44rem;
  background-image: url(/src/assets/img/customer.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}
</style>
